import { requests } from '../request-factory';

const unitOfMeasurementService = {
  getUnitsOfMeasurement: () => requests.get('unit-of-measurement'),
};

export default unitOfMeasurementService;
